module.exports = __webpack_public_path__ + "static/img/convocatoriaTEA-bicentenario_color.fea535e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/convocatoriaTEA-bicentenario_color.jpg
// module id = i5w1
// module chunks = 9